import { AxiosInstance } from "axios"

export interface StripeAccountOption {
  action: string
  label: string
  description: string
  linkType: string
  /** What the agent does on Stripe after following the link, in order. */
  steps: string[]
  primary: boolean
}

export interface GetStripeAccountOptionsResponse {
  time: string
  apiStatus: string
  data: {
    accountStatus: string
    message: string
    managedByAgency: boolean
    detailsSubmitted: boolean
    payoutsEnabled: boolean
    currentlyDue: string[]
    pastDue: string[]
    pendingVerification: string[]
    currentDeadline: number | null
    disabledReason: string | null
    errors: string[]
    options: StripeAccountOption[]
  }
}

/** Actions an agent can take on their Stripe Express payout account. */
export function getStripeAccountOptionsApi(axiosInstance: AxiosInstance) {
  return axiosInstance({
    method: "get",
    url: "/agent/stripe/account-options",
  }) as Promise<{ data: GetStripeAccountOptionsResponse }>
}
